import React from 'react'
import { SvgIcon } from '@mui/material'

export const PermissionsIcon = props => (
  <SvgIcon viewBox="0 0 24 24" sx={{ color: 'secondary.main' }} {...props}>
    <path d="M22 19h-6v-4h-2.68a7 7 0 1 1 0-6H24v6h-2v4Zm-4-2h2v-4h2v-2H11.94l-.23-.67a5 5 0 1 0 0 3.34l.23-.67H18v4ZM7 15a3 3 0 0 1-3-3 3 3 0 0 1 3-3 3 3 0 0 1 3 3 3 3 0 0 1-3 3Zm0-4a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1Z" />
  </SvgIcon>
)
